import { CalendarItemUnion } from '@akin-home/calendar/combined';
import { CheckListItem } from '@akin-home/checklists';
import React, { FC } from 'react';
import Checkbox from '../Checkbox';

export interface CalendarItemCheckboxProps {
  calendarItem: CalendarItemUnion;
  checklistItem: CheckListItem;
  fieldName?: string;
  onChange?: (calendarItem: CalendarItemUnion, item: CheckListItem) => void;
}

const CalendarItemCheckbox: FC<CalendarItemCheckboxProps> = ({
  calendarItem,
  checklistItem,

  onChange,
}) => {
  const onChecklistPress = (newVal: boolean) =>
    onChange?.(calendarItem, { ...checklistItem, checked: newVal });

  return (
    <Checkbox
      key={checklistItem.id}
      preset="circle"
      label={checklistItem.title?.replace(/(?:^|(?:[.!?]\s?))(\w)/, (val) =>
        val.toUpperCase()
      )}
      value={checklistItem.checked}
      onChange={onChecklistPress}
    />
  );
};

export default CalendarItemCheckbox;
